import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
        <Path
            fill={props.color ?? ds.colorValue.icon.primary}
            d="M7.416 2c1.049 0 1.713-.009 2.316.241l.22.105c.503.268.939.714 1.588 1.363l1.151 1.151.468.47c.443.447.807.831 1.076 1.184.368.481.603.96.603 1.528l-.01.209c-.05.478-.271.898-.593 1.32-.268.352-.633.736-1.076 1.184l-.468.469-1.467 1.467c-.657.657-1.184 1.186-1.654 1.544-.42.322-.84.542-1.319.592l-.209.01c-.567 0-1.047-.234-1.528-.602-.353-.268-.737-.633-1.185-1.076l-.469-.468-1.151-1.15c-.65-.65-1.095-1.086-1.363-1.589l-.105-.22C1.991 9.13 2 8.465 2 7.416V6.5c0-.928 0-1.675.078-2.26.08-.6.253-1.106.654-1.508l.156-.14c.373-.303.826-.443 1.351-.514C4.825 2 5.572 2 6.5 2h.916Zm-.424 3.55a1.001 1.001 0 1 0-1.415 1.417 1.001 1.001 0 0 0 1.415-1.416Z"
        />
    </Svg>
);
export default SvgComponent;
